import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { toast } from 'sonner';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { ShieldCheck } from 'lucide-react';

// Bloquea la app hasta que el usuario acepte y firme las políticas vigentes (también exigido por el servidor)
export const PolicyGate = ({ children }) => {
  const { user, logout } = useAuth();
  const [p, setP] = useState(null);
  const [f, setF] = useState({ signature_name: '', accept_privacy: false, accept_terms: false });
  useEffect(() => { if (user && user.role_id !== 'master') api.getPolicy().then((r) => setP(r.data)).catch(() => {}); }, [user]);
  if (!p || p.accepted) return children;
  const accept = async () => {
    try { await api.acceptPolicy(f); toast.success('SalesPRO: Políticas aceptadas y firmadas'); window.location.reload(); }
    catch (e) { toast.error(e.response?.data?.detail || 'SalesPRO: Error'); }
  };
  return (
    <div className="fixed inset-0 z-[100] bg-[#022C22]/90 grid place-items-center p-3" data-testid="policy-gate">
      <div className="bg-white rounded-xl w-full max-w-2xl max-h-[92vh] flex flex-col">
        <div className="p-4 border-b flex items-center gap-2"><ShieldCheck className="text-primary" /><h2 className="font-heading font-bold text-lg text-[#022C22]">Políticas de privacidad y condiciones de uso · versión {p.version}</h2></div>
        <pre className="p-4 overflow-y-auto text-xs whitespace-pre-wrap text-[#334155] flex-1" data-testid="policy-text">{p.text}</pre>
        <div className="p-4 border-t space-y-2">
          <label className="flex gap-2 text-sm"><input type="checkbox" checked={f.accept_privacy} onChange={(e) => setF({ ...f, accept_privacy: e.target.checked })} data-testid="policy-accept-privacy" /> Acepto las políticas de privacidad y el tratamiento de mis datos</label>
          <label className="flex gap-2 text-sm"><input type="checkbox" checked={f.accept_terms} onChange={(e) => setF({ ...f, accept_terms: e.target.checked })} data-testid="policy-accept-terms" /> Acepto las condiciones de uso del sistema</label>
          <Input placeholder="Firma digital: escribe tu nombre completo" value={f.signature_name} onChange={(e) => setF({ ...f, signature_name: e.target.value })} data-testid="policy-signature" />
          <div className="flex gap-2 justify-end">
            <Button variant="outline" onClick={logout}>Salir</Button>
            <Button onClick={accept} disabled={!f.accept_privacy || !f.accept_terms || f.signature_name.trim().length < 3} data-testid="policy-accept-btn">Aceptar y firmar</Button>
          </div>
          <p className="text-[10px] text-[#94A3B8]">Se guardará la fecha, la hora, tu firma y el texto exacto de esta versión.</p>
        </div>
      </div>
    </div>
  );
};

export default PolicyGate;
